import { Conf } from '../types/conf';
import { receiptEmails } from './receipt-emails';

export const conf: Conf = {
    receiptPages: {
        mit: '/skader/kvittering',
        www: '/anmeld-skade/kvittering',
        'medical-preassessment': '/skader/medicinsk-forhaandsvurdering-kvittering'
    },
    submitButtons: {
        default: 'Send anmeldelse',
        'medical-preassessment': 'Send ansøgning'
    },

    receiptEmails,

    apiEnabledForms: []
};
